import React from 'react';
import PropTypes from 'prop-types';

import Img from 'gatsby-image';
import Parser from 'html-react-parser';

class BlogQuote extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {input} = this.props
        const {quote,name_of_the_author,portrait_author} = input.primary
        return (
            <section>
            <div className="content">
                <blockquote>
                    {Parser(quote.html)}
                    <div className="portrait-author">
                        {portrait_author.localFile != null ? (
                            <Img fluid={portrait_author.localFile.childImageSharp.fluid} className="img-circle" />
                        ) : ''}                        
                        {name_of_the_author.text ? '— ' + name_of_the_author.text :''}
                    </div>  
                </blockquote>
            </div>
            </section>
        )
    }
}

BlogQuote.propTypes = {
    input: PropTypes.object.isRequired,
};

export default BlogQuote;